export type PdfFieldType =
	| 'text'
	| 'checkbox'
	| 'radio'
	| 'dropdown'
	| 'listbox'
	| 'signature'
	| 'button'
	| 'unknown';

export interface PdfFieldRect {
	x: number;
	y: number;
	width: number;
	height: number;
}

export interface PdfFieldOption {
	label: string;
	value: string;
}

export interface DetectedPdfField {
	id: string;
	fieldName: string;
	label: string;
	fieldType: PdfFieldType;
	pageIndex: number;
	rect: PdfFieldRect;
	options?: PdfFieldOption[];
	defaultValue?: string;
	exportValue?: string;
}
export interface PdfPageViewport {
	pageIndex: number;
	width: number;
	height: number;
}

export type DataType =
	| 'DO_NOT_VALIDATE'
	| 'SIGNATURE'
	| 'FIRST_NAME'
	| 'LAST_NAME'
	| 'FULL_NAME'
	| 'PHONE'
	| 'EMAIL'
	| 'ADDRESS_1'
	| 'ADDRESS_2'
	| 'FULL_ADDRESS'
	| 'STATE'
	| 'CITY'
	| 'ZIP_CODE';

/** Human-readable copy for each `DataType`, used in the Data Type dropdown and card. */
export const DATA_TYPE_LABELS: Record<DataType, string> = {
	DO_NOT_VALIDATE: 'Text',
	SIGNATURE: 'Signature',
	FIRST_NAME: 'First Name',
	LAST_NAME: 'Last Name',
	FULL_NAME: 'Full Name',
	PHONE: 'Phone',
	EMAIL: 'Email',
	ADDRESS_1: 'Address 1',
	ADDRESS_2: 'Address 2',
	FULL_ADDRESS: 'Full Address',
	STATE: 'State',
	CITY: 'City',
	ZIP_CODE: 'Zip Code',
};

/** All `DataType` values, in the fixed display order used by the dropdown. */
export const DATA_TYPE_VALUES: DataType[] = [
	'DO_NOT_VALIDATE',
	'SIGNATURE',
	'FIRST_NAME',
	'LAST_NAME',
	'FULL_NAME',
	'PHONE',
	'EMAIL',
	'ADDRESS_1',
	'ADDRESS_2',
	'FULL_ADDRESS',
	'STATE',
	'CITY',
	'ZIP_CODE',
];

export const DATA_TYPE_GROUPS: {
	title: string;
	helperText?: string;
	values: DataType[];
}[] = [
	{
		title: 'No Validation',
		values: ['DO_NOT_VALIDATE', 'SIGNATURE'],
	},
	{
		title: 'Validation',
		helperText: "Must exactly match the client's personal settings.",
		values: [
			'FIRST_NAME',
			'LAST_NAME',
			'FULL_NAME',
			'PHONE',
			'EMAIL',
			'ADDRESS_1',
			'ADDRESS_2',
			'FULL_ADDRESS',
			'STATE',
			'CITY',
			'ZIP_CODE',
		],
	},
];
export interface FieldConfig {
	fieldName: string;
	dataType: DataType;
	renamedLabel: string;
}
